import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { InventarioCapaService } from 'src/app/services/inventario-capa.service';

@Component({
  selector: 'app-modal-pedidos-encontrados',
  templateUrl: './modal-pedidos-encontrados.component.html',
  styleUrls: ['./modal-pedidos-encontrados.component.scss']
})
export class ModalPedidosEncontradosComponent implements OnInit {

  public pedidoDocumento;
  public pedidoIds = [];
  public isMobile: boolean;
  public isLoading = false;
  public allSelected = false;
  public someSelected = false;

  public displayedColumns: string[] = [];
  public paging = { index: 0, size: 5, length: 0 };
  public pedidoCollection: MatTableDataSource<any> = new MatTableDataSource<any>();

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild('allCheckbox') allCheckbox: MatCheckbox;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private inventarioCapaService: InventarioCapaService,
    private ref: MatDialogRef<ModalPedidosEncontradosComponent>,
    public router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar
  ) {
    this.pedidoDocumento = data.pedidoDocumento;
    this.isMobile = data.isMobile;
  }

  ngOnInit() {
    this.search();
    if (!this.isMobile) {
      this.displayedColumns = [
        'checkbox',
        'linha',
        'pedidoId',
        'documento',
        'volume',
        'cliente',
      ];
    } else {
      this.displayedColumns = [
        'checkbox',
        'pedidoId',
        'documento',
        'cliente',
      ];
    }
  }

  public search() {

    this.isLoading = true;
    this.pedidoCollection.data = null;
    this.inventarioCapaService.getInventarioContagemPedidosEncontrados({
      pedidoDocumento: this.pedidoDocumento,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size
    })
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any>) => {
          this.pedidoCollection.data = null;
          this.pedidoCollection.data = response.body;
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
          }
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  public getPartialText(text) {
    return text.length < 11 ? text.substring(0, 10) + '...' : text;
  }

  public updateSelection() {
    let total = 0;
    let selecteds = 0;

    if (this.pedidoCollection.data && this.pedidoCollection.data.length) {
      total = this.pedidoCollection.data.length;
      selecteds = this.pedidoCollection.data.filter(i => i.selected).length;
    }

    if (selecteds === 0) {
      this.allSelected = false;
      this.someSelected = false;
    } else if (selecteds < total) {
      this.allSelected = false;
      this.someSelected = true;
    } else {
      this.allSelected = true;
      this.someSelected = false;
    }
  }

  public select(item, selected: boolean) {
    item.selected = selected;
    if (selected === false) {
      var indexOf = this.pedidoIds.indexOf(item.pedidoId);
      if (indexOf > -1) {
        this.pedidoIds.splice(indexOf, 1);
        this.allSelected = false;
      }
    }
    else if (!this.pedidoIds.includes(item.pedidoId)) {
      this.pedidoIds.push(item.pedidoId);
    }
    this.updateSelection();
  }

  apply() {
    this.ref.close({ pedidoIds: this.pedidoIds });
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.search();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
